import { connect } from 'react-redux';
import { BuildingPermitWidget } from './building-permit-widget';
import { State } from 'store/state';
import { buildingPermitRequestsSelector } from 'store/state/domainData/selectors';


const mapStateToProps = (state: State) => ({
  buildingPermitRequests: buildingPermitRequestsSelector(state),
});

export default connect(mapStateToProps)(BuildingPermitWidget);
